import { Col, Divider, Form, Input, Row, Select } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import CustomDatePicker from '../../components/CustomDatePicker';
import InputMask from '../../components/input-mask';
import { ESTADOS, NACIONALIDADES } from '../../constants';
import {
  calcularDigitoVerificador,
  prefijos3Digitos,
  validarCaracterEspecial
} from '../../utils';
import { instanceRef } from '../../utils/axios';

const { Option } = Select;

const verificarDigito = (ruc) => {
  const documentoSplit = ruc.split('-');
  const nroDocumento = documentoSplit[0];
  const digito = documentoSplit[1];
  if (digito) {
    const digitoCalculado = calcularDigitoVerificador(nroDocumento);
    if (Number(digito) === digitoCalculado) {
      return true;
    }
  }
  return false;
};
const AseguradoCartaVerdeForm = ({ data, updateData, form }) => {
  const [departamentos, setDepartamentos] = useState([]);
  const [distritos, setDistritos] = useState([]);
  const [distritosTercero, setDistritosTercero] = useState([]);

  const getDepartamentos = async () => {
    try {
      const response = await instanceRef.instance.get(`data/departamentos`);
      const orderedDepartamentos = response.data.data.sort(function test(a, b) {
        if (a.descripcion < b.descripcion) {
          return -1;
        }
        if (a.descripcion > b.descripcion) {
          return 1;
        }
        return 0;
      });
      setDepartamentos(orderedDepartamentos);
      const { departamento, tercero } = data;
      const departamentoTercero = tercero.id_departamento;
      if (departamento) {
        await getDistritos({ departamento });
      }

      if (departamentoTercero) {
        await getDistritos({ departamentoTercero });
      }
    } catch (error) {
      // error
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const getDistritos = async ({ departamento, departamentoTercero }) => {
    try {
      const search = departamento || departamentoTercero;
      const response = await instanceRef.instance.get(
        `data/distritos?departamento=${search}`
      );
      const orderedDistritos = response.data.data.sort(function test(a, b) {
        if (a.descripcion < b.descripcion) {
          return -1;
        }
        if (a.descripcion > b.descripcion) {
          return 1;
        }
        return 0;
      });
      if (departamento) {
        setDistritos(orderedDistritos);
      } else if (departamentoTercero) {
        setDistritosTercero(orderedDistritos);
      }
    } catch (error) {
      // error
    }
  };

  const getDescriptions = useCallback(() => {
    const departamentoDescripcion =
      departamentos.find((item) => item.id === data.departamento)
        ?.descripcion || null;
    const distritoDescripcion =
      distritos.find((item) => item.id === data.distrito)?.descripcion || null;
    const departamentoTerceroDescripcion =
      departamentos.find((item) => item.id === data.tercero?.id_departamento)
        ?.descripcion || null;
    const distritoTerceroDescripcion =
      distritosTercero.find((item) => item.id === data.tercero?.id_distrito)
        ?.descripcion || null;

    return {
      departamentoDescripcion,
      distritoDescripcion,
      departamentoTerceroDescripcion,
      distritoTerceroDescripcion
    };
  }, [data, departamentos, distritos, distritosTercero]);

  useEffect(() => {
    const descriptions = getDescriptions();
    if (
      descriptions.departamentoDescripcion !== data.departamentoDescripcion ||
      descriptions.distritoDescripcion !== data.distritoDescripcion ||
      descriptions.departamentoTerceroDescripcion !==
        data.departamentoTerceroDescripcion ||
      descriptions.distritoTerceroDescripcion !==
        data.distritoTerceroDescripcion
    ) {
      updateData({ ...data, ...descriptions });
    }
  }, [getDescriptions, data, updateData]);

  useEffect(() => {
    getDepartamentos();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Form
      form={form}
      name="asegurado"
      scrollToFirstError
      initialValues={data}
      layout="vertical"
      noValidate
      onValuesChange={(changedValues, allValues) => updateData(allValues)}
    >
      <Divider>Confirme Datos del Asegurado</Divider>
      <Row
        gutter={[16, 0]}
        style={{
          marginTop: 'auto',
          marginBottom: 'auto',
          marginLeft: 'auto',
          marginRight: 'auto',
          textAlign: 'start'
        }}
      >
        {' '}
        {/* <Col xs={24} md={12}>
          <Form.Item
            label="Nombre y Apellido"
            name="nombres"
            rules={[{ required: true }]}
            onKeyPress={(e) => {
              const pressedKey = String.fromCharCode(
                !e.charCode ? e.which : e.charCode
              );
              validarCaracterEspecial(e, pressedKey);
            }}
            onPaste={(e) => {
              const pastedText = e.clipboardData.getData('text');
              validarCaracterEspecial(e, pastedText);
            }}
            onChange={(e) => {
              form.setFieldsValue({
                tercero: {
                  ...data.tercero,
                  nombres: e.target.value
                }
              });
              updateData({
                ...data,
                nombres: e.target.value,
                tercero: {
                  ...data.tercero,
                  nombres: e.target.value
                }
              });
            }}
          >
            <Input placeholder="Ingrese un valor" />
          </Form.Item>
        </Col> */}
        <Col xs={24} md={6}>
          <Form.Item
            label="Nombres"
            name="nombre"
            rules={[{ required: true }]}
            onKeyPress={(e) => {
              const pressedKey = String.fromCharCode(
                !e.charCode ? e.which : e.charCode
              );
              validarCaracterEspecial(e, pressedKey);
            }}
            onPaste={(e) => {
              const pastedText = e.clipboardData.getData('text');
              validarCaracterEspecial(e, pastedText);
            }}
            onChange={(e) => {
              updateData({
                ...data,
                nombre: e.target.value
              });
            }}
          >
            <Input placeholder="Ingrese un valor" />
          </Form.Item>
        </Col>
        <Col xs={24} md={6}>
          <Form.Item
            label="Apellidos"
            name="apellido"
            rules={[{ required: true }]}
            onKeyPress={(e) => {
              const pressedKey = String.fromCharCode(
                !e.charCode ? e.which : e.charCode
              );
              validarCaracterEspecial(e, pressedKey);
            }}
            onPaste={(e) => {
              const pastedText = e.clipboardData.getData('text');
              validarCaracterEspecial(e, pastedText);
            }}
            onChange={(e) => {
              updateData({
                ...data,
                apellido: e.target.value
              });
            }}
          >
            <Input placeholder="Ingrese un valor" />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item label="Cédula" name="cedula" rules={[{ required: true }]}>
            <Input placeholder="Ingrese un valor" />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label="RUC (Opcional)"
            name="ruc"
            rules={[
              {
                pattern: '^[0-9]{5,8}-[0-9]{1}$',
                message: 'Verificar formato. Ej.: 12345678-9'
              },
              {
                validator: (_, value) => {
                  if (value.length > 0) {
                    const digitoValido = verificarDigito(value);
                    if (!digitoValido) {
                      // eslint-disable-next-line prefer-promise-reject-errors
                      return Promise.reject(
                        `El dígito verificador no coincide`
                      );
                    }
                  }

                  return Promise.resolve();
                }
              }
            ]}
            validateTrigger="onBlur"
            onChange={(e) => {
              form.setFieldsValue({
                tercero: {
                  ...data.tercero,
                  ruc: e.target.value
                }
              });
              updateData({
                ...data,
                ruc: e.target.value,
                tercero: {
                  ...data.tercero,
                  ruc: e.target.value
                }
              });
            }}
          >
            <Input placeholder="Ej.: 12345678-9" />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label="Celular"
            name="celular"
            rules={[{ required: true }]}
          >
            <InputMask
              mask="(999) 999-999"
              placeholder="(___) ___-___"
              addonBefore={data.prefix}
              disabled
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label="Correo"
            name="correo"
            validateTrigger="onBlur"
            rules={[
              { required: true },
              {
                type: 'email',
                message: 'El correo no es válido'
              }
            ]}
            onChange={(e) => {
              form.setFieldsValue({
                tercero: {
                  ...data.tercero,
                  correo: e.target.value
                }
              });
              updateData({
                ...data,
                correo: e.target.value,
                tercero: {
                  ...data.tercero,
                  correo: e.target.value
                }
              });
            }}
          >
            <Input placeholder="Ingrese un valor" />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label="Departamento"
            name="departamento"
            rules={[{ required: true, message: 'Requerido' }]}
          >
            <Select
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              style={{ width: '100%' }}
              optionFilterProp="children"
              placeholder="Elegir departamento"
              onChange={(value) => {
                form.setFieldsValue({ distrito: undefined });
                updateData({
                  ...data,
                  distrito: null,
                  departamento: value
                });
                getDistritos({
                  departamento: value
                });
              }}
            >
              {departamentos.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.descripcion}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label="Ciudad"
            name="distrito"
            rules={[{ required: true, message: 'Requerido' }]}
          >
            <Select
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              style={{ width: '100%' }}
              placeholder="Elegir distrito"
            >
              {distritos.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.descripcion}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label="Domicilio"
            name="domicilio"
            rules={[{ required: true, message: 'Requerido' }]}
            onChange={(e) => {
              form.setFieldsValue({
                tercero: {
                  ...data.tercero,
                  domicilio: e.target.value
                }
              });
              updateData({
                ...data,
                domicilio: e.target.value,
                tercero: {
                  ...data.tercero,
                  domicilio: e.target.value
                }
              });
            }}
          >
            <Input placeholder="Ingrese un valor" />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item label="Nacionalidad" name="nacionalidad">
            <Select style={{ width: '100%' }} placeholder="Elegir un valor">
              {NACIONALIDADES.map(({ descripcion }) => (
                <Option key={descripcion} value={descripcion}>
                  {descripcion}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item label="Sexo" name="sexo" rules={[{ required: true }]}>
            <Select style={{ width: '100%' }} placeholder="Elegir sexo">
              <Option value="Masculino">Masculino</Option>
              <Option value="Femenino">Femenino</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label="Estado civil"
            name="estadoCivil"
            rules={[{ required: true }]}
          >
            <Select
              style={{ width: '100%' }}
              placeholder="Elegir un estado civil"
            >
              {ESTADOS.map(({ descripcion }) => (
                <Option key={descripcion} value={descripcion}>
                  {descripcion}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item label="Lugar Nacimiento" name="lugarNacimiento">
            <Input placeholder="Ingrese un valor" />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label="Fecha Nacimiento"
            name="fechaNacimiento"
            rules={[{ required: true }]}
          >
            <CustomDatePicker
              style={{ width: '100%' }}
              placeholder="DD/MM/YYYY"
              format="DD/MM/YYYY"
            />
          </Form.Item>
        </Col>
        <br />
      </Row>
      <Divider>Confirme Datos de Facturación</Divider>
      <Row gutter={[16, 0]} style={{ margin: 'auto' }}>
        <Col xs={24} md={12} align="start">
          <Form.Item
            label="Razón Social"
            name={['tercero', 'nombres']}
            rules={[{ required: true, message: 'Requerido' }]}
          >
            <Input placeholder="Ingrese un valor" />
          </Form.Item>
        </Col>
        <Col xs={24} md={12} align="start">
          <Form.Item
            label="CI / RUC"
            name={['tercero', 'ruc']}
            rules={[
              { required: true, message: 'Requerido' },
              {
                validator: (_, value) => {
                  if (value && value.includes('-')) {
                    const digitoValido = verificarDigito(value);
                    if (!digitoValido) {
                      // eslint-disable-next-line prefer-promise-reject-errors
                      return Promise.reject(
                        `El dígito verificador no coincide`
                      );
                    }
                  }

                  return Promise.resolve();
                }
              }
            ]}
            validateTrigger="onBlur"
          >
            <Input placeholder="Ej.: 12345678-9" />
          </Form.Item>
        </Col>
        <Col xs={24} md={12} align="start">
          <Form.Item
            label="Correo"
            name={['tercero', 'correo']}
            rules={[
              {
                type: 'email',
                message: 'El correo no es válido'
              }
            ]}
          >
            <Input placeholder="Ingrese un valor" type="email" />
          </Form.Item>
        </Col>
        <Col xs={24} md={12} align="start">
          <Form.Item label="Departamento" name={['tercero', 'id_departamento']}>
            <Select
              showSearch
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              style={{ width: '100%' }}
              optionFilterProp="children"
              placeholder="Elegir departamento"
              onChange={(value) => {
                form.setFieldsValue({
                  tercero: {
                    ...data.tercero,
                    id_distrito: undefined,
                    id_departamento: value
                  }
                });
                updateData({
                  ...data,
                  tercero: {
                    ...data.tercero,
                    id_distrito: undefined,
                    id_departamento: value
                  }
                });

                getDistritos({ departamentoTercero: value });
              }}
            >
              {departamentos.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.descripcion}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12} align="start">
          <Form.Item label="Ciudad" name={['tercero', 'id_distrito']}>
            <Select
              showSearch
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              style={{ width: '100%' }}
              placeholder="Elegir distrito"
            >
              {distritosTercero.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.descripcion}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12} align="start">
          <Form.Item label="Dirección" name={['tercero', 'domicilio']}>
            <Input placeholder="Ingrese un valor" />
          </Form.Item>
        </Col>

        <Col xs={24} md={12} align="start">
          <Form.Item
            label="Celular"
            name={['tercero', 'celular']}
            rules={[
              {
                pattern: `^\\((${prefijos3Digitos.join(
                  '|'
                )})\\) [0-9]{3}-[0-9]{3}$`,
                message: 'Número no válido'
              }
            ]}
          >
            <InputMask
              mask="(999) 999-999"
              placeholder="(___) ___-___ (OPCIONAL)"
              addonBefore="+595"
            />
          </Form.Item>
        </Col>

        {/* <Col xs={24} md={12} align="start">
          <Form.Item
            label="Teléfono (Línea Baja)"
            onKeyPress={validarCaracterTelefono}
            onPaste={validarCaracterTelefono}
          >
            <Input.Group compact>
              <Form.Item
                name={['tercero', 'grupoTelefono', 'prefijoTelefono']}
                noStyle
                rules={[
                  {
                    min: 3,
                    message: 'Como mínimo debe contener 3 dígitos'
                  },
                  {
                    max: 4,
                    message: 'Como máximo debe contener 4 dígitos'
                  }
                ]}
              >
                <Input
                  placeholder="0531"
                  style={{ width: '25%' }}
                  // onChange={(e) => {
                  //   setPrefijoTelefono(e.target.value);
                  // }}
                  // onBlur={(e) => {
                  //   handleFormTerceroChange(
                  //     e.target,
                  //     'grupoTelefono',
                  //     'prefijoTelefono'
                  //   );
                  // }}
                />
              </Form.Item>
              <Form.Item
                name={['tercero', 'grupoTelefono', 'sufijoTelefono']}
                noStyle
                rules={[
                  {
                    min: 5,
                    message: 'Como mínimo debe contener 5 dígitos'
                  }
                ]}
              >
                <Input placeholder="000 000" style={{ width: '75%' }} />
              </Form.Item>
            </Input.Group>
          </Form.Item>
        </Col> */}
      </Row>
    </Form>
  );
};

export default AseguradoCartaVerdeForm;
